var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGeolocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "GeoAlt",
    clipPath: "url(#clip0_36_1072)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.2075 11.175C14.5525 12.5025 13.665 13.825 12.7575 15.0125C11.8966 16.132 10.9761 17.2044 10 18.225C9.02385 17.2044 8.10336 16.132 7.2425 15.0125C6.335 13.825 5.4475 12.5025 4.7925 11.175C4.13 9.83375 3.75 8.5775 3.75 7.5C3.75 5.8424 4.40848 4.25269 5.58058 3.08058C6.75269 1.90848 8.3424 1.25 10 1.25C11.6576 1.25 13.2473 1.90848 14.4194 3.08058C15.5915 4.25269 16.25 5.8424 16.25 7.5C16.25 8.5775 15.8688 9.83375 15.2075 11.175ZM10 20C10 20 17.5 12.8925 17.5 7.5C17.5 5.51088 16.7098 3.60322 15.3033 2.1967C13.8968 0.790176 11.9891 0 10 0C8.01088 0 6.10322 0.790176 4.6967 2.1967C3.29018 3.60322 2.5 5.51088 2.5 7.5C2.5 12.8925 10 20 10 20Z",
    fill: "#512DA8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10 10C9.33696 10 8.70107 9.73661 8.23223 9.26777C7.76339 8.79893 7.5 8.16304 7.5 7.5C7.5 6.83696 7.76339 6.20107 8.23223 5.73223C8.70107 5.26339 9.33696 5 10 5C10.663 5 11.2989 5.26339 11.7678 5.73223C12.2366 6.20107 12.5 6.83696 12.5 7.5C12.5 8.16304 12.2366 8.79893 11.7678 9.26777C11.2989 9.73661 10.663 10 10 10ZM10 11.25C10.9946 11.25 11.9484 10.8549 12.6517 10.1517C13.3549 9.44839 13.75 8.49456 13.75 7.5C13.75 6.50544 13.3549 5.55161 12.6517 4.84835C11.9484 4.14509 10.9946 3.75 10 3.75C9.00544 3.75 8.05161 4.14509 7.34835 4.84835C6.64509 5.55161 6.25 6.50544 6.25 7.5C6.25 8.49456 6.64509 9.44839 7.34835 10.1517C8.05161 10.8549 9.00544 11.25 10 11.25Z",
    fill: "#512DA8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_36_1072"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeolocation);
export default __webpack_public_path__ + "static/media/geolocation.64079c2d66da18377b6495bfc79e620c.svg";
export { ForwardRef as ReactComponent };